// extracted by mini-css-extract-plugin
module.exports = {"MenuBurger":"styles_MenuBurger__13oKl","MenuBurgerItem":"styles_MenuBurgerItem__2745o"};